import * as borogove from "borogove";

const hideSchemes =
	/^(?:tel:|xmpp:|bitcoin:|bitcoincash:|monero:|ethereum:|https:\/\/(?:www\.)?patreon\.com\/c\/|https:\/\/liberapay\.com\/)/;

const Item = ({
	className,
	item,
}: {
	className: string;
	item: borogove.ProfileItem;
}) => {
	return (
		<>
			{className !== "email" &&
				item.text().map((value, idx) => (
					<span key={idx} className={`p-${className}`}>
						{value}
					</span>
				))}
			{className === "email" &&
				item
					.text()
					.filter((v) => v !== "")
					.map((value, idx) => (
						<a className={`u-${className}`} key={idx} href={`mailto:${value}`}>
							{value}
						</a>
					))}
			{item.uri().map((value, idx) => (
				<a className={`u-${className}`} key={idx} href={value}>
					{value.replace(hideSchemes, "")}
				</a>
			))}
			{item.date().map((value, idx) => (
				<time className={`dt-${className}`} key={idx} dateTime={value}>
					{value}
				</time>
			))}
		</>
	);
};

export const Profile = ({ profile }: { profile: borogove.Profile }) => {
	return (
		<div className="h-card profile">
			{profile.properties().map((key) => (
				<>
					{profile.get(key).map((item, idx) => (
						<Item key={`${key}/${idx}`} className={key} item={item} />
					))}
				</>
			))}
		</div>
	);
};
